import { ReactElement } from 'react';

import { Translate } from '@dreryk/react-common';
import { IconSize, InfoRoundIcon, StrongText, StyledFlex, Tooltip } from '@dreryk/react-components';

import { practitionersTranslationKeys } from '../../../../../translations';

export const DefaultConfidentialityModeCellHeader = (): ReactElement => {
   return (
      <StyledFlex gap={'4px'} alignItems={'center'}>
         <StrongText testId={'defaultConfidentialityMode'}>
            <Translate>{practitionersTranslationKeys.table.defaultDataMode}</Translate>
         </StrongText>
         <Tooltip
            testId={'defaultConfidentialityModeInfo'}
            content={<Translate>{practitionersTranslationKeys.table.defaultConfidentialityLevelDescription}</Translate>}
         >
            <InfoRoundIcon testId={'defaultConfidentialityModeInfo'} size={IconSize.SMALL} />
         </Tooltip>
      </StyledFlex>
   );
};
